import 'slick-carousel';

const $suitesSlider = $('#signature-slider');
const $control = $('#signature-suites-slider-control');

const $suitesSliderCounter = $('.signature-suites-slider .js-slick-slider-top-counter');

$suitesSlider.on('init reInit afterChange', (event, slick, currentSlide) => {
  const i = (currentSlide ? currentSlide : 0) + 1;

  $suitesSliderCounter.text(`${i}/${slick.slideCount}`);
});

$suitesSlider.slick({
  cssEase: 'ease',
  fade: false,
  infinite: true,
  pauseOnFocus: true,
  pauseOnHover: false,
  speed: 500,
  variableWidth: true,
  slidesToScroll: 1,
  appendArrows: $control,
  arrows: true,
  prevArrow: '<i class="icon-button-arrow-prev"></i>',
  nextArrow: '<i class="icon-button-arrow-next"></i>',
  centerMode: true
});

const resortSlider = $('.js-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  prevArrow: '<button aria-label="Previous" class="prev resort-slider-arrow"><i class="icon icon-button-arrow-prev"></i></button>',
  nextArrow: '<button aria-label="Next" class="next resort-slider-arrow"><i class="icon icon-button-arrow-next"></i></button>'
});

resortSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  const nextImg = slick.$slides[nextSlide];
  const srcImg = nextImg.dataset.src;

  nextImg.src = srcImg;
  nextImg.addEventListener('load', () => {
    nextImg.style.opacity = 1;
  });
});